export const headersMovements = [
  { text: "fecha", value: "date", width: "120px", fixed: true },
  { text: "Movimiento", value: "type" },
  { text: "Cantidad", value: "quantity" },
  { text: "Producto", value: "product.description" },
  { text: "Zona", value: "zone.name" },
  { text: "Referencia", value: "reference" },
  { text: "Usuario", value: "user.fullName" },
];

export const headersRequests = [
  { text: "Referencia", value: "ref" },
  { text: "Estado", value: "status" },
  { text: "Solicitante", value: "user.fullName" },
  { text: "Fecha", value: "requestDate" },
  { text: "Acciones", value: "actions" },
];

export const headersMassiveEmployees = [
  { text: "", value: "flag" },
  { text: "RUT", value: "rut" },
  { text: "Nombres", value: "names" },
  { text: "Apellido Paterno", value: "fatherName" },
  { text: "Apellido Materno", value: "motherName" },
  { text: "Centro de Costo", value: "costCenter" },
  { text: "Email", value: "email" },
  { text: "Genero", value: "gender" },
  { text: "Posicion", value: "position" },
  { text: "Talla Zapatos", value: "sizeMescal" },
  { text: "Talla Pantalones", value: "sizePants" },
  { text: "Talla Uniforme", value: "sizeUniform" },
  { text: "RUT Manager", value: "managerRut" },
  { text: "Nombre Manager", value: "managerName" },
];

export const headersMassiveInventory = [
  { text: "", value: "flag" },
  { text: "Producto", value: "product" },
  { text: "Cantidad", value: "quantity" },
  { text: "Referencia", value: "reference" },
  { text: "Proveedor", value: "supplier" },
  { text: "Zona", value: "zone" },
  { text: "Errores", value: "errors" },
];

export const headersRegulariceStok = [
  { text: "", value: "flag" },
  { text: "Producto", value: "product" },
  { text: "Cantidad", value: "quantity" },
  { text: "Referencia", value: "reference" },
  { text: "Zona", value: "zone" },
  { text: "Errores", value: "errors" },
];

export const headersUpdatePrices = [
  { text: "", value: "flag" },
  { text: "Producto", value: "product" },
  { text: "Precio", value: "price" },
];

export const errorCreatedEmployees = [
  { text: "", value: "flag" },
  { text: "RUT", value: "rut" },
  { text: "Nombres", value: "firstName" },
  { text: "Apellido Paterno", value: "fatherName" },
  { text: "Apellido Materno", value: "motherName" },
  { text: "Centro de Costo", value: "costCenter" },
];

export const headersProducts = [
  { text: "", value: "flag" },
  { text: "Categoria", value: "category" },
  { text: "Codigo", value: "code" },
  { text: "Talla", value: "size" },
  { text: "Descripcion", value: "description" },
  { text: "Precio", value: "price" },
  { text: "Proveedor", value: "supplier" },
  { text: "Genero", value: "gender" },
];

export const headersDeliveriesReport = [
  { text: "fecha", value: "date", width: "110px", fixed: true },
  { text: "RUT", value: "rut" },
  { text: "Empleado", value: "employee" },
  { text: "Centro", value: "costCenter" },
  { text: "Categoria", value: "category" },
  { text: "Producto", value: "product" },
  { text: "Precio", value: "price" },
  { text: "Referencia", value: "reference" },
  { text: "Entrega", value: "dateEntrega", width: "110px", fixed: true },
];
